import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CardsWithTables from '../components';


function mapStateToProps() {
  return {
  };
}

function mapDispatchToProps() {
  return {
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CardsWithTables));



// WEBPACK FOOTER //
// ./src/routes/Embed/CallForImpact/CardWithTables/container/index.js